var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95838 12.9298L15.1571 5.73109C15.281 5.60707 15.426 5.54373 15.5921 5.54109C15.7582 5.53846 15.9059 5.60179 16.0353 5.73109C16.1646 5.8604 16.2292 6.00887 16.2292 6.17651C16.2292 6.34429 16.1646 6.49283 16.0353 6.62214L8.48567 14.1846C8.33498 14.3352 8.15921 14.4105 7.95838 14.4105C7.75755 14.4105 7.58178 14.3352 7.43109 14.1846L3.95192 10.7055C3.82803 10.5814 3.76692 10.4342 3.76859 10.2638C3.77012 10.0935 3.83553 9.94373 3.96484 9.81443C4.09414 9.68512 4.24262 9.62047 4.41025 9.62047C4.57803 9.62047 4.72657 9.68512 4.85588 9.81443L7.95838 12.9298Z",
    fill: "#0E88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.252e8a7336cabc50997d7b77a0965983.svg";
export { ForwardRef as ReactComponent };